
import React from 'react';
import OcrField from './ocr_field';

const OcrFieldsData = props => {
    let mappedByPosition = {};
    let mappedByAddress = {};
    let validAddress = true;
    // let hasAddressValues = false;
    for (const [key, value] of Object.entries(props.data)) {
        if (value.show) {
            let valueTranslation = null;
            if (value.name === "gender" && value.value !== "")
                valueTranslation = props?.translationsKeys["kw_ocr_field_gender_" + value.value];
            // if(value.name=)   
            if (value.name === "id_type" && value.valid && value.value !== "") {
                if (value.value === 1)
                    valueTranslation = props?.translationsKeys["kw_ocr_field_type_kw_id"];
                if (value.value === 2)
                    valueTranslation = props?.translationsKeys["kw_ocr_field_type_passport"];
                if (value.value === 3)
                    valueTranslation = props?.translationsKeys["kw_ocr_field_type_gcc_id"];
                if (value.value === 4)
                    valueTranslation = props?.translationsKeys["kw_ocr_field_type_bedoon"];

            }
            let dateValue = null;
            if (value.date_format && value.value !== "") {
                const splitDate = value.value.split("-");
                dateValue = splitDate[1] + "." + splitDate[2] + "." + splitDate[0];
            }

            mappedByPosition = {
                ...mappedByPosition,
                [value.order]: {
                    key,
                    ...value,
                    valueTranslation: valueTranslation,
                    value: dateValue ? dateValue : value.value

                }
            }
        }
        if (value.show_address_modal && value.order_address) {
            mappedByAddress = {
                ...mappedByAddress,
                [value.order_address]: {
                    key,
                    ...value
                }
            }
            if (!value.valid)
                validAddress = false;

            // if (value.value !== "")
            //     hasAddressValues = true;
        }
    };

    return (
        <div className="ocr-fields-review">
            {Object.keys(mappedByPosition).map(key => {
                return <OcrField
                    ocrType={props.ocrType}
                    key={mappedByPosition[key].key}
                    data={mappedByPosition[key]}
                    translatedValueDesc={props?.translationsKeys["kw_ocr_field_type_" + mappedByPosition[key].key]}
                    placeholderValueDesc={props?.translationsKeys["kw_ocr_field_placeholder_" + mappedByPosition[key].key]}
                    requiredTranslation={props?.translationsKeys["kw_ocr_field_required"]}
                    //genderTranslation={genderTranslation}
                    mappedByAddress={mappedByPosition[key].key === "full_address" ? mappedByAddress : null}
                    submitAddressData={mappedByPosition[key].key === "full_address" ? props.submitAddressData : null}
                    governorateAreasList={mappedByPosition[key].key === "full_address" ? props.governorateAreas : null}
                    validAddress={validAddress}
                    hasAddressValues={props.proccessFinished}
                    updateContactData={mappedByPosition[key].key === "311" ? props.updateContactData : null}
                    setArea={mappedByPosition[key].key === "full_address" ? props.setArea : null}
                />
            }
            )}
        </div>

    );
}


export default OcrFieldsData;
